export function setupPortraitKeyboardResize(): void {
  const TAG = '[portrait-kbd]';
  console.log(`${TAG} init`);

  if (typeof document === 'undefined' || typeof window === 'undefined') {
    console.warn(`${TAG} no document/window, skip`);
    return;
  }

  const meta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement | null;
  if (!meta) {
    console.warn(`${TAG} no <meta name="viewport"> found, skip`);
    return;
  }
  console.log(`${TAG} meta viewport initial:`, meta.getAttribute('content'));

  const mql = window.matchMedia('(orientation: portrait) and (pointer: coarse)');
  console.log(`${TAG} mql initial matches=`, mql.matches, {
    orientation_portrait: window.matchMedia('(orientation: portrait)').matches,
    pointer_coarse: window.matchMedia('(pointer: coarse)').matches,
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
  });

  const vv = window.visualViewport ?? null;
  console.log(`${TAG} visualViewport supported=`, !!vv);
  let vvAttached = false;

  const updateInset = (): void => {
    if (!vv) {
      return;
    }
    const inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    document.documentElement.style.setProperty('--sia-keyboard-inset', `${inset}px`);
    console.log(`${TAG} updateInset`, {
      innerHeight: window.innerHeight,
      vv_height: vv.height,
      vv_offsetTop: vv.offsetTop,
      inset,
    });
  };

  const attachVv = (): void => {
    if (!vv || vvAttached) {
      console.log(`${TAG} attachVv skipped`, { vv: !!vv, vvAttached });
      return;
    }
    vv.addEventListener('resize', updateInset);
    vv.addEventListener('scroll', updateInset);
    vvAttached = true;
    console.log(`${TAG} VV listeners attached`);
    updateInset();
  };

  const detachVv = (): void => {
    if (!vv || !vvAttached) {
      document.documentElement.style.removeProperty('--sia-keyboard-inset');
      console.log(`${TAG} detachVv (nothing to remove, var cleared)`);
      return;
    }
    vv.removeEventListener('resize', updateInset);
    vv.removeEventListener('scroll', updateInset);
    vvAttached = false;
    document.documentElement.style.removeProperty('--sia-keyboard-inset');
    console.log(`${TAG} VV listeners detached, var cleared`);
  };

  const apply = (matches: boolean): void => {
    console.log(`${TAG} apply matches=`, matches);
    const current = meta.getAttribute('content') ?? '';
    const entries = current
      .split(',')
      .map((e) => e.trim())
      .filter((e) => e.length > 0 && !e.toLowerCase().startsWith('interactive-widget'));

    if (matches) {
      entries.push('interactive-widget=resizes-content');
    }

    const next = entries.join(', ');
    meta.setAttribute('content', next);
    console.log(`${TAG} meta viewport now:`, next);

    if (matches) {
      attachVv();
    } else {
      detachVv();
    }
  };

  apply(mql.matches);
  mql.addEventListener('change', (e) => {
    console.log(`${TAG} mql change matches=`, e.matches);
    apply(e.matches);
  });
}
